import type { ItemType } from "@/types/item";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const fetchPopularItems = async (
  limit: number,
  companyId?: string
): Promise<ItemType[]> => {
  const response = await axios.get(
    `https://kaman.rest/api/popular-items?limit=${limit}${
      companyId ? `&company_id=${companyId}` : ""
    }`
  );
  const items = response.data.data.popular_items.map((newItem: any) => ({
    id: newItem.id,
    name: newItem.name,
    description: newItem.description,
    price: newItem.price,
    image: newItem.image,
    companyName: newItem.company.name,
    companyId: newItem.company.id,
    categoryName: newItem.category.name,
  }));
  console.log("pop items", items);
  return items.sort((a: ItemType, b: ItemType) => b.price - a.price);
};

export const usePopularItems = ({
  limit = 10,
  companyId,
}: {
  limit?: number;
  companyId?: string;
}) => {
  return useQuery<ItemType[]>({
    queryKey: ["popularItems", limit, companyId],
    queryFn: () => fetchPopularItems(limit, companyId),
  });
};
